import React from 'react';
import authConfig from "../../authConfig"
import Button from 'react-bootstrap/Button';
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { setLoginState, logout } from "../../redux/authSlice";
/**
 * AuthFooterButon
 * A button component for authentication footers.
 * Props:
 * - label: string - The text to display on the button.
 * - onClick: function - The click handler for the button.
 * - disabled: boolean - Whether the button is disabled.
 */
const AuthFooterButon = ({ label, onClick, disabled = false }) => {
    const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogin = () => {
        navigate("/membersarea");
    };
    const handleLogout = async () => {
        try {
            const res = await axios.post(
                authConfig.api.urls.getAuthLogout,
                {},
                { withCredentials: true }
            );
        } catch (e) {

        }
        dispatch(setLoginState({ isLoggedIn: false, user: null }));
        navigate("/membersarea");
    }
    return (
        <>
            {isLoggedIn ? (
                <Button variant="danger" size="sm" onClick={handleLogout}>Member Logout</Button>
            ) : (
                <Button variant="success" size="sm" onClick={handleLogin}>Member Login</Button>
            )}   
            
        </>
        
    );
};

export default AuthFooterButon;